import { EventType, SourcePages, Features } from 'lib/EventSchema';
import { EventData } from 'lib/EventLogger/Event';

export enum LocationSearchActions {
  editLocation = 'edit_location',
  enterCityField = 'enter_city_field',
  currentLocation = 'current_location',
  selectCity = 'select_city',
}

interface LocationSearchTapEventInfo {
  action: LocationSearchActions;
}

const event = ({ action }: LocationSearchTapEventInfo): EventData => {
  return {
    event_type: EventType.engagement,
    source_page: SourcePages.Home,
    feature: Features.setLocation,
    engagement_type: `${action}_tap`,
  };
};

export default event;
